import type { PreOrderStatus } from '../../types/catalog';

export const PRE_ORDER_STATUS_LABELS: Record<PreOrderStatus, string> = {
  NEW: 'Новий',
  CONFIRMED: 'Підтверджено',
  FULFILLED: 'Реалізовано',
  CANCELLED: 'Скасовано',
};

export const PRE_ORDER_STATUS_COLORS: Record<PreOrderStatus, 'primary' | 'info' | 'success' | 'default'> = {
  NEW: 'primary',
  CONFIRMED: 'info',
  FULFILLED: 'success',
  CANCELLED: 'default',
};
